import { createEntityAdapter } from '@reduxjs/toolkit'

import { Driver } from './models/Driver'

export const driversAdapter = createEntityAdapter({
  selectId: (driver: Driver) => driver.id,
})